import Vue from "vue";
import "bootstrap/dist/js/bootstrap.bundle";
import accounting from "accounting";
import BootstrapVue from "bootstrap-vue";
import clone from "clone";
import lodash from "lodash";
import multiselect from "vue-multiselect";
import pluralize from "pluralize";
import sweetAlert from "sweetalert";
import toastr from "toastr";
import { Ability } from "@casl/ability";
import { abilitiesPlugin } from "@casl/vue";

import "./element-ui";
import "./vue-tables";
import "./v-tooltip";
import "./progress-bar";

window.accounting = accounting;
window.clone = clone;
window.pluralize = pluralize;
window.sweetAlert = sweetAlert;
window.toastr = toastr;
window.toastr.options.positionClass = "toast-bottom-right";
window.toastr.options.timeOut = 5000;
window.toastr.options.toastClass = "toastr";

Vue.use(
  abilitiesPlugin,
  new Ability([], {
    subjectName: (subject) => (typeof subject === "string" ? subject : subject.entityName),
  })
);

Vue.use(BootstrapVue);
Object.defineProperty(Vue.prototype, "$lodash", { value: lodash });

Vue.component("Multiselect", multiselect);
